
import { Box, Divider, Collapse, Typography, Stack, IconButton, Accordion, AccordionSummary, Autocomplete } from '@mui/material';
import PropTypes from 'prop-types';
import Scrollbar from 'src/components/Scrollbar';
import Label from 'src/components/Label';
import LabelInput from 'src/components/LabelInput';
import { fDateTime } from 'src/utils/formatTime';
import actionCriarNotas from 'src/actions/chats/notas/actionCriarNotas';
import { useState } from 'react';
import { useSnackbar } from 'notistack';

import { useEffect } from 'react';
import DrawerNegocioNotasInput from './DrawerNegocioNotasInput';
import NovoContatoForm from '../../cadastro/NovoContatoForm';
import Iconify from 'src/components/Iconify';
import { RowInput } from 'src/components/forms/RowInput';
import InputStyle from 'src/components/InputStyle';
import buscarCep from 'src/actions/chats/buscarCep';
import PhoneInput from 'react-phone-number-input'
import { formataNumeroCelular, maskCPF, maskDate } from 'src/utils/functions';
import v2_actionPesquisarContatos from 'src/actions/v2/contatos/v2_actionPesquisarContatos';
import InputStyleAutocomplete from 'src/components/InputStyleAutocomplete';
import v2_actionEditarContato from 'src/actions/v2/contatos/v2_actionEditarContato';
import ModalNovoContato from 'src/sections/@chats/chat/Modals/ModalNovoContato';
import { Input } from 'src/@/components/ui/input';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { Button } from 'src/@/components/ui/button';


import { Command, CommandGroup, CommandInput, CommandItem } from "src/@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "src/@/components/ui/popover";
import { X } from "lucide-react";


DrawerContatos.propTypes = {
    isCollapse: PropTypes.bool,
    onCollapse: PropTypes.func
};

const ItemSearchContacts = ({
    onOpenModalContact,
    onClear,
    contactId,
    onOpen,
    open,
    pesquisa,
    changePesquisa,
    listaContatos,
    onSelect
}) => {
    console.log('contactId', contactId)
    return (

        <div className="w-full mt-4">
            <div className="flex items-center space-x-2">
                <Popover open={open} onOpenChange={onOpen}>
                    <PopoverTrigger asChild>
                        <Button
                            variant="outline"
                            className="w-[350px] justify-start text-left"
                        >
                            {contactId
                                ? `${contactId.nome} - ${formataNumeroCelular(contactId.telefone)}`
                                : "Escolha um contato"}
                        </Button>
                    </PopoverTrigger>

                    <PopoverContent className="w-[300px] p-0">
                        <div className="relative">
                            <input
                                type="text"
                                placeholder="Pesquise o contato..."
                                value={pesquisa}
                                onChange={(e) => changePesquisa(e.target.value)}
                                className="w-full p-2 border border-gray-300 rounded-md"
                            />

                            <div className="absolute w-full bg-white border border-gray-200 rounded-md mt-1 max-h-60 overflow-y-auto">
                                {listaContatos.length > 0 ? (
                                    listaContatos.map((option) => (
                                        <div
                                            key={option._id}
                                            onClick={() => onSelect(option)}
                                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                        >
                                            {option.nome} - {formataNumeroCelular(option.telefone)}
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center py-2">
                                        <p className="text-sm text-gray-500">Nenhum contato encontrado</p>
                                        <button
                                            onClick={onOpenModalContact}
                                            className="mt-2 px-3 py-1 border border-gray-300 rounded-md text-sm hover:bg-gray-100"
                                        >
                                            Criar Contato
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </PopoverContent>
                </Popover>

                {contactId ? (
                    <Button
                        size="icon"
                        variant="ghost"
                        onClick={onClear}
                    // onClick={() => {
                    //   setContactId(null);
                    //   onEditarContatoId(null);
                    // }}
                    >
                        <X className="w-4 h-4" />
                    </Button>
                ) : (
                    <Button
                        // onClick={() => setStateModalNovoContato(true)}
                        onClick={onOpenModalContact}
                        size="icon"
                        className="bg-slate-500 text-white hover:bg-slate-600"
                    >
                        <Iconify icon="mdi:account-plus" />
                    </Button>
                )}
            </div>
        </div>
    )

}


export default function DrawerContatos({
    user,
    cliente,
    lead,
    onEditarContatoId,
    callbackCreateContact
}) {

    const { enqueueSnackbar } = useSnackbar();
    const [pesquisa, setPesquisa] = useState('');
    const [contactId, setContactId] = useState(lead?.contato);
    const [isChange, setIsChange] = useState(null);
    const [loadingEditarContato, setLoadingEditarContato] = useState(null);
    const [stateModalNovoContato, setStateModalNovoContato] = useState(null);
    const [open, setOpen] = useState(false);
    const [refresh, setRefresh] = useState(0); // Estado adicional para forçar re-render
    const [listaContatos, setListaContatos] = useState([]);

    const [contato, setContato] = useState({
        nome: lead?.contato?.nome,
        email: lead?.contato?.info?.email,
        whatsapp: lead?.contato?.telefone,
        dataNascimento: lead?.contato?.info?.dataNascimento,
        cpf: lead?.contato?.info?.cpf
    });
    const [endereco, setEndereco] = useState({
        cep: lead?.contato?.info?.endereco?.cep,
        rua: lead?.contato?.info?.endereco?.rua,
        numero: lead?.contato?.info?.endereco?.numero,
        bairro: lead?.contato?.info?.endereco?.bairro,
        cidade: lead?.contato?.info?.endereco?.cidade,
        estado: lead?.contato?.info?.endereco?.estado,
        complemento: lead?.contato?.info?.endereco?.complemento
    });

    async function pesquisarContatos(pesquisa) {
        try {
            const result = await v2_actionPesquisarContatos(null, pesquisa); // Ajuste o parâmetro se necessário
            setListaContatos(result.data.data);
            setRefresh((prev) => prev + 1); // Força atualização do key
        } catch (error) {
            console.log(error);
        }
    }


    async function pesquisarContatos(pesquisa) {
        try {
            const result = await v2_actionPesquisarContatos(cliente._id, pesquisa)
            setListaContatos(result.data.data)
        } catch (error) {
            console.log(error);
        }
    }

    async function editarContato() {
        setLoadingEditarContato(true);
        try {
            let data =
            {
                scope: {
                    nome: contato.nome,
                    telefone: contato.telefone,
                    info: {
                        email: contato.email,
                        cpf: contato.cpf,
                        dataNascimento: contato.dataNascimento,
                        endereco: {
                            cep: endereco.cep,
                            rua: endereco.rua,
                            bairro: endereco.bairro,
                            cidade: endereco.cidade,
                            estado: endereco.estado,
                            numero: endereco.numero,
                            complemento: endereco.complemento
                        }
                    }
                }
            }

            await v2_actionEditarContato(contactId._id, data)
            setLoadingEditarContato(false);
            setIsChange(false);
            enqueueSnackbar('Contato alterado com sucesso', { variant: 'success', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        } catch (error) {
            setLoadingEditarContato(false);
            console.log(error);
        }
    }

    const handleOnBlurSearchCep = async (zipCode) => {
        try {
            const address = await buscarCep(zipCode)
            if (!address.erro) {
                setEndereco({
                    cep: address.cep,
                    rua: address.logradouro,
                    bairro: address.bairro,
                    cidade: address.localidade,
                    estado: address.uf,
                })
            }
        } catch (address) {

        }
    }

    useEffect(() => {
        setContato({
            nome: lead?.contato?.nome,
            email: lead?.contato?.info?.email,
            whatsapp: lead?.contato?.telefone,
            dataNascimento: lead?.contato?.info?.dataNascimento,
            cpf: lead?.contato?.info?.cpf
        });
        setEndereco({
            cep: lead?.contato?.info?.endereco?.cep,
            rua: lead?.contato?.info?.endereco?.rua,
            numero: lead?.contato?.info?.endereco?.numero,
            bairro: lead?.contato?.info?.endereco?.bairro,
            cidade: lead?.contato?.info?.endereco?.cidade,
            estado: lead?.contato?.info?.endereco?.estado,
            complemento: lead?.contato?.info?.endereco?.complemento
        });
        setContactId(lead?.contato);
    }, [lead, contactId]);

    useEffect(() => {
        if (listaContatos.length > 0) {
            console.log('listaContatos', listaContatos)
        }
    }, [listaContatos]);

    return (
        <Stack>

            <ModalNovoContato
                cliente={cliente}
                user={user}
                open={stateModalNovoContato}
                listaRespostas={[]}
                listaClientesCanais={[]}
                callbackAddContact={async (data) => {
                    await onEditarContatoId(data._id);
                    callbackCreateContact()
                }}
                onClose={() => {
                    setStateModalNovoContato(false);
                }}

            />

            <ItemSearchContacts
                contactId={contactId}
                listaContatos={listaContatos}
                onOpenModalContact={() => setStateModalNovoContato(true)}
                onClear={() => {
                    setContactId(null);
                    onEditarContatoId(null);
                }}
                onOpen={() => setOpen(!open)}
                open={open}
                pesquisa={pesquisa}
                changePesquisa={e => {
                    setPesquisa(e);
                    if (e.length > 3) {
                        pesquisarContatos(e);
                    } else {
                        setListaContatos([]);
                    }
                }}
                onSelect={(option) => {
                    setContactId(option);
                    onEditarContatoId(option._id);
                    setOpen(false);
                }}
            />


            <Divider sx={{ my: 2, borderStyle: 'dashed' }} />

            <Scrollbar
                // sx={{ height: { xs: '30vh', md: '30vh', lg: '30vh', xl: '40vh' } }}
                spacing={2}
            >

                <Box sx={{ mt: 3 }}>


                    {contactId && (
                        <div className='flex flex-col gap-4'>

                            <div className="flex flex-row gap-2">
                                <RowInput
                                    isRequired={true}
                                    label="Nome"
                                    input={<Input onChange={e => {
                                        setContato({ ...contato, nome: e.target.value })
                                        setIsChange(true);
                                    }}
                                        value={contato.nome}
                                        variant="outlined"
                                        className="h-8"
                                        size="small"
                                        fullWidth
                                    />}
                                />
                                <RowInput
                                    isRequired={true}
                                    label="Telefone"
                                    input={<PhoneInput
                                        defaultCountry='BR'
                                        style={{ padding: 4, borderRadius: 4, border: '1px solid #ededed' }}
                                        placeholder="Insira seu numero"
                                        value={contato.whatsapp}
                                        onChange={value => {
                                            setIsChange(true);
                                            setContato({ ...contato, whatsapp: value })
                                        }}
                                    />}
                                />
                            </div>
                            <div className="flex flex-row gap-2">
                                <RowInput
                                    label="Data Nascimento"
                                    input={<Input onChange={e => {
                                        setContato({ ...contato, dataNascimento: e.target.value });
                                        setIsChange(true);
                                    }}
                                        value={contato.dataNascimento && maskDate(contato.dataNascimento)}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                    />}
                                />
                                <RowInput
                                    label="Email"
                                    type="email"
                                    input={<Input onChange={e => {
                                        setContato({ ...contato, email: e.target.value });
                                        setIsChange(true);
                                    }}
                                        value={contato.email}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                    />}
                                />
                                <RowInput
                                    label="CPF"
                                    input={<Input onChange={e => {
                                        setContato({ ...contato, cpf: e.target.value });
                                        setIsChange(true);
                                    }}
                                        value={contato.cpf && maskCPF(contato.cpf)}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                    />}
                                />
                            </div>

                            <div className="w-1/3">
                                <RowInput
                                    label="CEP"

                                    input={<Input onChange={e => {
                                        setEndereco({ ...endereco, cep: e.target.value })
                                        setIsChange(true);
                                    }}
                                        onBlur={e => handleOnBlurSearchCep(e.target.value)}
                                        value={endereco.cep}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                    />}
                                />
                            </div>

                            <div className="flex flex-row gap-2">
                                <RowInput
                                    label="Rua"
                                    input={<Input onChange={e => {
                                        setEndereco({ ...endereco, rua: e.target.value })
                                        setIsChange(true);
                                    }} value={endereco.rua} variant="outlined" size="small" fullWidth />}
                                />
                                <div className="w-1/6">
                                    <RowInput
                                        label="Número"
                                        input={<Input onChange={e => {
                                            setEndereco({ ...endereco, numero: e.target.value });
                                            setIsChange(true);
                                        }} value={endereco.numero} variant="outlined" size="small" fullWidth />}
                                    />
                                </div>

                                <RowInput
                                    label="Bairro"
                                    input={<Input onChange={e => {
                                        setEndereco({ ...endereco, bairro: e.target.value });
                                        setIsChange(true);
                                    }} value={endereco.bairro} variant="outlined" size="small" fullWidth />}
                                />
                            </div>


                            <div className="flex flex-row gap-2">
                                <RowInput
                                    label="Complemento"
                                    input={<Input onChange={e => {
                                        setEndereco({ ...endereco, complemento: e.target.value })
                                        setIsChange(true);
                                    }} value={endereco.complemento} variant="outlined" size="small" fullWidth />}
                                />
                                <RowInput
                                    label="Cidade"
                                    input={<Input onChange={e => {
                                        setEndereco({ ...endereco, cidade: e.target.value })
                                        setIsChange(true);
                                    }} value={endereco.cidade} variant="outlined" size="small" fullWidth />}
                                />
                                <RowInput
                                    label="Estado"
                                    input={<Input onChange={e => {
                                        setEndereco({ ...endereco, estado: e.target.value });
                                        setIsChange(true);
                                    }} value={endereco.estado} variant="outlined" size="small" fullWidth />}
                                />
                            </div>


                            {isChange && (
                                <div>
                                    <ButtonLoading className="bg-slate-700" onClick={editarContato} loading={loadingEditarContato}>Salvar alterações</ButtonLoading>
                                </div>
                            )}

                        </div>
                    )}


                </Box>


            </Scrollbar>

        </Stack>

    );
}
